/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { decryptedAdminID, MyModal } from "../../../utility";
import ModalContainer from "../../../components/modal_popup";
import { ImCross } from "react-icons/im";
import { MenuItem, TextField } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  CandidateRegisteredActions,
  commonPopupActions,
} from "../../../redux-store/store";
import { AiOutlineClose } from "react-icons/ai";
import {
  GetCallRemainderInterview,
  PutResolve,
  PutCalRemainder,
  getcandidateDetails,
  getCandidateLead,
  GetAllAdminDetails,
} from "../../../apiServices";
import SuccessTick from "../../../components/success_tick";
import { MdNotificationAdd } from "react-icons/md";
import { TiTick } from "react-icons/ti";

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#f4f4f4",
    // maxWidth: "850px",
    // width: "100%",
  },
  tableWrapper: {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarGutter: "stable", // Reserves space for scrollbar to prevent layout shift
  },
  table: {
    width: "70vw",
    borderCollapse: "collapse",
  },
  th: {
    backgroundColor: "#808080",
    color: "#fff",
    padding: "10px",
    textAlign: "left",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid #ddd",
    // position: "relative",
  },
  truncatedText: {
    whiteSpace: "nowrap", // Prevents text from wrapping
    overflow: "hidden", // Hides overflow
    textOverflow: "ellipsis", // Adds ellipsis (…) for overflowed text
    maxWidth: "150px", // Set the max width of the cell content
    cursor: "pointer", // Shows pointer on hover
  },
  ellipsisContainer: {
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // position: "absolute",
    // right: "40px",
    // top: "50%",
    // transform: "translateY(-50%)",
    cursor: "pointer",
  },
  modalContent: {
    width: "400px",
    padding: "10px",
    fontSize: "16px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
};

function CandidateCallRemainder({
  setopencallremainder,
  initialReminderData,
  onclose,
}) {
  const admin = decryptedAdminID();
  const [callData, setCallData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showLater, setShowLater] = useState(false);
  const [showResolved, setShowResolved] = useState(false);
  const [dateTimeError, setDateTimeError] = useState(false);
  const [notesError, setNotesError] = useState(false);
  const [dateTime, setDateTime] = useState(""); // Declare dateTime state
  const [adminId, setAdminId] = useState(admin); // Directly use adminId as a state
  const [notes, setNotes] = useState(""); // Declare notes state
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setloading] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [reminderData, setReminderData] = useState(initialReminderData);
  const adminDetails = useSelector((state) => state.adminDetails);
  const Dispatch = useDispatch();

  let isSuperAdmin = adminDetails.roleID == 1;
  useEffect(() => {
    async function fetchData() {
      try {
        setloading(true);
        const today = new Date().toISOString().split("T")[0];

        const data = await GetCallRemainderInterview(adminId, today);
        setloading(false);
        setCallData(data.data); // Set API response data
      } catch (error) {
        console.error("Error fetching call remainder data:", error);
      }
    }

    fetchData();
  }, [adminId]); // Empty dependency array ensures this runs only once on component mount

  useEffect(() => {
    GetAllAdminDetails()
      .then((data) => {
        console.log(data);
        const activeAdmins = data.filter(
          (item) => !item.Deactived && item.Module !== "Developer"
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something Went wrong");
      });
  }, []);

  useEffect(() => {
    console.log("reminderData:", reminderData);
  }, [reminderData]);

  const handleCandidateDetails = async (candidateId, type) => {
    console.log(candidateId, "candidateid");

    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };

  const handleEmployersDetails = (id, type) => {
    console.log(id);

    Dispatch(
      commonPopupActions.setShowPopup({
        name: type,
        id: id,
      })
    );
  };

  const handleAssignToChange = (e) => {
    const { value } = e.target;
    console.log("Selected adminId:", value); // Log selected value
    setAdminId(value); // Directly update adminId
  };

  const handleCloseLater = () => {
    setShowLater(false); // Close the modal
    setDateTime(""); // Reset dateTime
    setNotes(""); // Reset notes
    setDateTimeError(false); // Reset any errors
    setNotesError(false); // Reset any errors
  };

  const handleResolve = async (id) => {
    try {
      const response = await PutResolve(id);
      await GetCallRemainderInterview();
      if (response) {
        console.log("Follow-up marked as resolved:", response);
        setCallData(callData.filter((item) => item.id !== id)); // Remove resolved item from list
        setShowSuccess(true); // Show success feedback modal
        setShowResolved(false);

        setTimeout(() => {
          setShowSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error resolving call remainder:", error);
    }
  };

  const handleCallReminder = async () => {
    setDateTimeError(false);
    setNotesError(false);

    const [callRemainderDate, callRemainderTime] = dateTime.split("T");
    const formattedCallRemainderTime = `${callRemainderTime}:00`;

    // Validate required fields
    if (!dateTime || !notes) {
      if (!dateTime) setDateTimeError(true);
      if (!notes) setNotesError(true);
      return; // Exit if validation fails
    }

    const payload = {
      id: selectedId,
      callRemainderDate,
      callRemainderTime: formattedCallRemainderTime,
      notes,
    };

    try {
      // Make the API call
      const response = await PutCalRemainder(selectedId, payload);

      // Manually fetch the updated list
      const today = new Date().toISOString().split("T")[0];
      const data = await GetCallRemainderInterview({
        adminId: decryptedAdminID(),
        callRemainderDate: today,
        isResolved: false,
      });
      setCallData(data.data); // Set API response data

      console.log("Follow-up updated successfully:", response);

      // Clear form fields
      setDateTime("");
      setNotes("");
      setSelectedId("");
      setShowSuccess(true); // Show success feedback modal
      setShowLater(false);
      setTimeout(() => {
        setShowSuccess(false);
      }, 2000);
    } catch (error) {
      console.error("Error updating Call Remainder:", error);
      alert("Failed to update call remainder. Please try again.");
    }
  };

  const handleDateTimeChange = (e) => {
    setDateTime(e.target.value);
    if (e.target.value) setDateTimeError(false); // Clear error if value is filled
  };

  const handleNotesChange = (e) => {
    setNotes(e.target.value);
    if (e.target.value) setNotesError(false); // Clear error if value is filled
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h4 style={{ margin: 0 }}>Today call/followup details</h4>
        {/* <button
          className="btn btn-danger"
          onClick={() => {
            // setopencallremainder(false);
            onclose();
          }}
        >
          <AiOutlineClose />
        </button> */}
        <div style={{ display: "flex", alignItems: "center" }}>
          {isSuperAdmin && (
            <TextField
              onChange={handleAssignToChange}
              name="AssignedTo"
              id="AssignedTo"
              className="form-control"
              select
              label="Assigned To"
              value={adminId || ""} // Default to empty string if undefined
              size="small" // Make the TextField small
              style={{ width: "200px", marginRight: "10px" }} // Set width and spacing to the right
            >
              {/* <MenuItem value={-1}>ALL</MenuItem> */}
              {adminList.map((el) => (
                <MenuItem key={el.id} value={el.id}>
                  {el.userName}
                </MenuItem>
              ))}
            </TextField>
          )}
          <button
            className="btn btn-danger"
            onClick={() => {
              // setopencallremainder(false);
              onclose();
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <AiOutlineClose />
          </button>
        </div>
      </div>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Title</th>
              <th style={styles.th}>Notes</th>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Time</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" style={{ color: "", textAlign: "center" }}>
                  <div className="d-flex align-items-center justify-content-center mt-5">
                    <div className="spinner-border spinner-border-sm text-dark"></div>
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {callData && callData.length > 0 ? (
                  callData.map((item) => (
                    <tr key={item.id}>
                      {item.canId != null && (
                        <td style={styles.td}>
                          <a
                            href={`/candidate/${item.canId.id}/RegisterCandidate`} // Dynamic URL for candidate
                            style={{ textDecoration: "none", color: "blue" }} // Optional: remove underline & inherit color
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default link behavior (if required)
                              handleCandidateDetails(
                                item.canId.id,
                                "RegisterCandidate"
                              );
                            }}
                          >
                            {item.canId.firstName}
                          </a>
                        </td>
                      )}
                      {item.canLeadId != null && (
                        <td style={styles.td}>
                          <a
                            href={`/candidate-lead/${item.canLeadId.id}/CandidateLead`} // Dynamic URL for candidate lead
                            style={{ textDecoration: "none", color: "blue" }} // Optional: remove underline & inherit color
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default link behavior (if required)
                              handleCandidateDetails(
                                item.canLeadId.id,
                                "CandidateLead"
                              );
                            }}
                          >
                            {item?.canLeadId?.name ? item.canLeadId.name : "No Name"}

                          </a>
                        </td>
                      )}
                      {item.empId != null && (
                        <td style={styles.td}>
                          <a
                            href={`/employer/${item.empId.id}/EmployerDetails`} // Dynamic URL for employer
                            style={{ textDecoration: "none", color: "blue" }} // Optional: remove underline & inherit color
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default link behavior (if required)
                              handleEmployersDetails(
                                item.empId.id,
                                "EmployerDetails"
                              );
                            }}
                          >
                            {item.empId.companyName}
                          </a>
                        </td>
                      )}

                      {item.canId != null && (
                        <td style={styles.td}>Candidate</td>
                      )}
                      {item.canLeadId != null && (
                        <td style={styles.td}>Candidate Lead</td>
                      )}
                      {item.empId != null && (
                        <td style={styles.td}>Employer</td>
                      )}
                      <td style={styles.td}>{item.remainderSubject}</td>
                      <td style={styles.td}>
                        <div style={styles.truncatedText} title={item.notes}>
                          {item.notes}
                        </div>
                      </td>
                      <td style={styles.td}>{item.callRemainderDate}</td>
                      {/* <td style={styles.td}>{item.callRemainderTime}</td> */}
                      <td
                        style={styles.td}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>{item.callRemainderTime}</div>
                        <div className="ms-2 d-flex align-items-center">
                          <TiTick
                            title="Resolved"
                            src="" // Replace with the actual path
                            alt="Resolved"
                            style={{
                              color: "green",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              marginRight: "8px",
                            }}
                            onClick={() => {
                              setSelectedId(item.id);
                              setShowResolved(true);
                            }}
                          />
                          <MdNotificationAdd
                            title="Remain Later"
                            src="" // Replace with the actual path
                            alt="Remain Later"
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedId(item.id);
                              setShowLater(true);
                            }}
                          />
                        </div>
                      </td>

                      {/* <td style={styles.td} className="d-flex justify-content-end">
                    <div>{item.callRemainderTime}</div>
                    <div
                      style={styles.ellipsisContainer}
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="ms-2"
                    >
                      <BsThreeDotsVertical />
                    </div>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => {
                            setSelectedId(item.id);
                            setShowResolved(true);
                          }}
                        >
                          Resolved
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => {
                            setSelectedId(item.id);
                            setShowLater(true);
                          }}
                        >
                          Remain Later
                        </a>
                      </li>
                    </ul>
                  </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ color: "red", textAlign: "center" }}
                    >
                      <div className="mt-5">No data available</div>
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>

      {showSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={<SuccessTick HeadText="Successfully" />}
          />
        </MyModal>
      )}

      {showLater && (
        <MyModal>
          <ModalContainer
            childComponent={
              <div style={styles.modalContent}>
                <h5 className="d-flex justify-content-between align-items-center">
                  <span>Remainder update</span>
                  <button
                    className="btn btn-danger"
                    onClick={handleCloseLater}
                    style={{
                      cursor: "pointer",
                      marginLeft: "20px",
                    }}
                  >
                    <AiOutlineClose />
                  </button>
                </h5>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <label
                    htmlFor="dateTime"
                    style={{
                      fontWeight: "bold",
                      flex: "1",
                    }}
                  >
                    Date & Time
                  </label>
                  {/* <button
                    className="btn btn-danger"
                    onClick={handleCloseLater}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      right: 0,
                      bottom: "1px",
                    }}
                  >
                    <AiOutlineClose />
                  </button> */}
                </div>
                <input
                  type="datetime-local"
                  id="dateTime"
                  value={dateTime}
                  onChange={handleDateTimeChange}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "8px",
                    margin: "10px 0",
                  }}
                  min={new Date().toISOString().slice(0, 16)} // Set the minimum date-time to the current date and time
                />

                {dateTimeError && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    Date & Time is required
                  </div>
                )}
                <div>
                  <label htmlFor="notes" style={{ fontWeight: "bold" }}>
                    Notes
                  </label>
                  <textarea
                    id="notes"
                    value={notes}
                    onChange={handleNotesChange}
                    rows="1"
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "8px",
                      margin: "10px 0",
                      resize: "vertical",
                    }}
                  />
                  {notesError && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      Notes are required
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "10px",
                  }}
                >
                  <button
                    style={{
                      border: "1px solid #169c50",
                      backgroundColor: "transparent",
                      color: "#169c50",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      outline: "none",
                      fontWeight: "bold",
                    }}
                    onClick={handleCallReminder}
                  >
                    Submit
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}

      {showResolved && (
        <MyModal>
          <ModalContainer
            childComponent={
              <div style={styles.modalContent}>
                <h5 className="d-flex justify-content-between w-100">
                  <span>
                    <b>Confirmation</b>
                  </span>
                  <button
                    className="btn btn-danger"
                    onClick={() => setShowResolved(false)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <AiOutlineClose />
                  </button>
                </h5>

                <p
                  style={{
                    textAlign: "left",
                    // marginTop: "15px",
                    // fontWeight: "bold",
                  }}
                >
                  Are you sure you have completed the follow-up ?
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    // marginTop: "12px",
                  }}
                >
                  <button
                    style={{
                      border: "1px solid #169c50",
                      backgroundColor: "transparent",
                      color: "#169c50",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      outline: "none",
                      fontWeight: "bold",
                    }}
                    onClick={() => handleResolve(selectedId)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}
    </div>
  );
}

export default CandidateCallRemainder;
